import epics from './AthletePhysique.epics'

export { epics };